module.exports = __webpack_public_path__ + "img/Product_Services_2.09e53ffa.png";